import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import api from "../../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/concierge/message", { ...form, channel: "web" });
      toast.success("Concierge will respond within 24 hours");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Please try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="contact-page" className="bg-poche-black text-white">
      <section className="container-x py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Joseph Poche Concierge</p>
          <h1 className="font-serif text-6xl md:text-7xl mt-4 leading-[0.95]">A house, in hand.</h1>
          <p className="text-white/65 mt-6 leading-relaxed">
            Whether you are securing a Legacy Edition or simply seeking guidance on contour and fit —
            our concierge is available across every channel that matters.
          </p>
          <div className="mt-10 space-y-5">
            {[
              { i: Mail, t: "Email", v: "concierge@josephpoche.com" },
              { i: MessageCircle, t: "WhatsApp", v: "+1 (212) 555-0177" },
              { i: Phone, t: "Phone", v: "+44 20 7946 0177" },
              { i: MapPin, t: "Atelier", v: "Lagos · Milan · Geneva" },
            ].map((c, i) => (
              <div key={i} className="flex items-center gap-4 border-t border-white/10 pt-5">
                <c.i size={18} className="text-poche-gold flex-shrink-0" strokeWidth={1.4} />
                <div>
                  <div className="text-[10px] tracking-luxury uppercase text-white/45">{c.t}</div>
                  <div className="text-base">{c.v}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="md:col-span-7 glass-dark p-10">
          <h2 className="font-serif text-3xl">Send a message</h2>
          <form onSubmit={submit} className="space-y-5 mt-6">
            <div>
              <label className="text-[10px] tracking-luxury uppercase text-white/55">Name</label>
              <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-transparent border-b border-white/25 focus:border-poche-gold py-3 text-white focus:outline-none" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxury uppercase text-white/55">Email</label>
              <input data-testid="contact-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-transparent border-b border-white/25 focus:border-poche-gold py-3 text-white focus:outline-none" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxury uppercase text-white/55">Message</label>
              <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-transparent border-b border-white/25 focus:border-poche-gold py-3 text-white focus:outline-none" />
            </div>
            <button data-testid="contact-submit" disabled={busy} className="btn-gold w-full justify-center disabled:opacity-60">
              {busy ? "Sending…" : "Send to Concierge"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
